const LOAD_CELLO_JWT = 'twineApp/cello/LOAD_CELLO_JWT';
const LOAD_CELLO_JWT_SUCCESS = 'twineApp/cello/LOAD_CELLO_JWT_SUCCESS';
const LOAD_CELLO_JWT_FAIL = 'twineApp/cello/LOAD_CELLO_JWT_FAIL';

const initialState = {
  loading: false,
  error: null,
  token: null,
  userId: null,
};

export default function reducer(state = initialState, action = {}) {
  switch (action.type) {
    case LOAD_CELLO_JWT:
      return {
        ...state,
        loading: true,
        error: null,
      };

    case LOAD_CELLO_JWT_SUCCESS: {
      const r = action.result;
      return {
        ...state,
        loading: false,
        error: null,
        userId: action.userId,
        token: action?.result?.token ?? null,
      };
    }

    case LOAD_CELLO_JWT_FAIL:
      return {
        ...state,
        loading: false,
        error: action.error,
        token: null,
        userId: null,
      };

    default:
      return state;
  }
}

export function loadCelloJwtToken(userId) {
  return {
    userId,
    types: [LOAD_CELLO_JWT, LOAD_CELLO_JWT_SUCCESS, LOAD_CELLO_JWT_FAIL],
    promise: (client) => client.get(`/users/${userId}/cello-jwt-token`),
  };
}
